import {AbstractControl, FormGroup, ValidationErrors, ValidatorFn} from '@angular/forms';

export function errorSeverityValidator(fg: FormGroup): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const feedbackTypeControl = fg.get('feedbackType');
    if (feedbackTypeControl) {
      const feedbackType = feedbackTypeControl.value;
      if (feedbackType != "Error") {
        return null;
      } else {
        if (control.value != "Unknown") {
          return null;
        }
        return {ErrorSeverityMustBeSet: true};
      }
    }
    return null;
  }
}
